import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { register } from 'swiper/element/bundle';
import * as Sentry from '@sentry/angular';

register();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error('Error bootstrapping application:', err);
    Sentry.captureException(err);
  });
